module.exports = __webpack_public_path__ + "926bb80e083162f3fa197d30f526f6af.svg";